import React, { ChangeEvent } from 'react'
import { Form, InputGroup } from 'react-bootstrap'
import classNames from 'classnames'
import { WidgetProps } from '@rjsf/utils'
import { CustomWidgetProps } from '../FormCitation/FormCitation'

export const CustomPercentageWidget: React.FC<WidgetProps> = (props) => {
  const { value, disabled, onChange } = props
  const { fieldContainerClass, isEditing, citationButton } = props.options as CustomWidgetProps

  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    const newValue = e.target.value
    if (newValue === '') {
      onChange(null)
      return
    }
    const numValue = parseFloat(newValue)
    if (numValue >= 0 && numValue <= 100) {
      onChange(numValue)
    }
  }

  return (
    <div className={fieldContainerClass}>
      <InputGroup>
        <Form.Control
          type='number'
          value={value ?? ''}
          className={classNames({
            'form-control border-0 disabled-contact-information-field': disabled,
          })}
          onChange={handleChange}
          disabled={disabled}
          min={0}
          max={100}
          step='0.1'
          placeholder='0'
        />
        {isEditing ? <InputGroup.Text>%</InputGroup.Text> : <span className='me-2 align-content-center text-muted'>%</span>}
      </InputGroup>
      {!isEditing && value ? citationButton : null}
    </div>
  )
}
